import { useOfferContext } from '../../../context';
import { Agent } from 'shared/components/OfferCard/Agent';

export const OfferAgentContainer = () => {
  const { offer } = useOfferContext();

  const { isByHomeowner, user } = offer;
  const { cianUserId, agencyName, profileUri } = user || {};

  return <Agent agentName={agencyName} cianUserId={cianUserId} isByHomeowner={isByHomeowner} url={profileUri} />;
};
